module.exports = __webpack_public_path__ + "static/media/57.4a7d8c80.jpg";